module.exports = __webpack_public_path__ + "img/dummyprod6@1x.0a75f993.png";